export class StorePriceModel {
  storePriceId: number = 0;
  branchId: number = 0;
  storeId: number = 0;
  articleId: number = 0;
  unitValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
